import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteNav } from '@/mocks/site';

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  const solid = scrolled || open;

  const isActive = (to: string) => {
    if (to.includes('#')) return false;
    if (to === '/') return location.pathname === '/';
    return location.pathname.startsWith(to);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="w-full px-4 md:px-8 flex items-center justify-between gap-4">
        <Link
          to="/"
          className="flex items-center gap-3 shrink-0 group"
          aria-label="爆料官网 首页"
        >
          <span
            className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
              solid ? 'bg-primary-500 text-background-50' : 'bg-background-50/15 text-background-50 backdrop-blur'
            }`}
          >
            <i className="ri-flashlight-fill text-xl" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-bold tracking-wide ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              爆料官网
            </span>
            <span
              className={`font-label text-[10px] tracking-[0.3em] uppercase mt-0.5 ${
                solid ? 'text-foreground-500' : 'text-background-200/80'
              }`}
            >
              Baoliao Portal
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {siteNav.map((item) => {
            const active = isActive(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 rounded-md text-sm font-label transition-colors ${
                  solid
                    ? active
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                    : active
                      ? 'bg-background-50/20 text-background-50'
                      : 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/about#submit"
            className="hidden sm:inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label px-4 py-2.5 rounded-md transition-colors whitespace-nowrap"
          >
            <i className="ri-send-plane-fill" aria-hidden="true" />
            投稿爆料
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              solid ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
            }`}
          >
            <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden mt-3 px-4 pb-4">
          <nav className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 overflow-hidden" aria-label="移动端导航">
            {siteNav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="px-5 py-3.5 text-sm font-label text-foreground-800 border-b border-background-200/70 last:border-0 hover:bg-background-100 transition-colors"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about#submit"
              className="px-5 py-3.5 text-sm font-label bg-primary-500 text-background-50 flex items-center gap-2"
            >
              <i className="ri-send-plane-fill" aria-hidden="true" />
              投稿爆料
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}